export class NotAuthenticatedException extends Error {
    public constructor() {
        super("User is not Authenticated yet.");
        Object.setPrototypeOf(this, NotAuthenticatedException.prototype);
    }
}
